import { generateFragment, HashNavigationRouteActionKind } from "client/Features/Navigation/routing";
import { ensureNotNil } from "client/Misc/utils";

export function generateUserDetailsUrl(userId: string): string {
	return "#" + ensureNotNil(
		generateFragment({
			action: HashNavigationRouteActionKind.UserDetails,
			params: {
				userId: userId
			},
			queryParams: {}
		})
	);
}